import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

import routes from './routes.js'
const instance =  new Router({
    mode:'history',
    routes
});

// import store from '@/store'
// import config from '@/config.js'
// instance.beforeEach((to, from, next) => {
//     //If we're not heading to login AND we are logged out, block
//     if(
//         to.name !== config.ROUTER_LOGIN_PAGE_NAME &&
//         !store.getters['auth/isLoggedIn']
//     ){ next({ name:config.ROUTER_LOGIN_PAGE_NAME }) }
//     else{ next() }
// })
export default instance;
